import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { databasesActions } from '@src/store/reducers/databasesReducer';

export const createDatabasesMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [databasesActions.GET_SCHEMAS]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envID}/Schemas`);
            const list = response.data;
            next({ type: databasesActions.SET_SCHEMAS, payload: { items: list } });
            return response.data;
        },
        [databasesActions.GET_SCHEMA_PROPERTIES]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envID}/Schemas/${payload.schemaId}`);
            const data = response.data;
            next({ type: databasesActions.SET_SCHEMA_PROPERTIES, payload: { schemaProperties: data, status: '' } });
            return response.data;
        },
        [databasesActions.SAVE_SCHEMA_PROPERTIES]: async ({ payload }: any) => {
            const url = `${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.envID}/Schemas/${payload.schemaId}`;
            const response = await http.post(url, payload.params);
            return response.data;
        },
        [databasesActions.TEST_CONNECT_TO_SCHEMA]: async ({ payload }: any, next: Next) => {
            //check projid is correct
            const url = `${restServiceUrl}Projects/${payload.projId}/Environments/${payload.envId}/Schemas/${payload.schemaId}/Utils/Test`;
            const response = await http.post(url, payload.params);
            next({ type:databasesActions.TEST_CONNECT_STATUS, payload: { status: response.data } });
            return response;
        },
        [databasesActions.TEST_CONNECT]: async ({ payload }: any, next: Next) => {
            try {
                const postData = {
                    projectDraft: payload.project,
                    connectionProps: payload.connectionProperties,
                    recEnvId: payload.environmentId,
                    recTempEnvId: payload.environmentTempId
                };
                const response = await http.post(`${restServiceUrl}Projects/Utils/TestConnection`, postData);
                next({ type: databasesActions.TEST_CONNECT, payload: { status_test_schema: response.data } });

                return response.data;
            } catch (e) {
            }
        },
        [databasesActions.GET_CONN_TEMPLATE]: async ({ payload }: any) => {
            const url = `${restServiceUrl}DBTemplate/${payload.manageOrUnmanage}/${payload.dbTypeId}`;
            const response = await http.get(url);
            return response.data;
        },
        [databasesActions.SWITCH_TAB]: async ({ payload }: any) => {
            const url = `${restServiceUrl}Projects/ConnectionType/${payload.dbTypeId}/Utils/ConectionPropertiesSet`;
            const response = await http.post(url, payload.connectionProperties);
            return response.data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/databases.middleware.ts